import React, { useEffect, useState } from "react";
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'left',
        color: theme.palette.text.secondary,
    },
}));

function TextInput(props) {
    return (
        <TextField
            label={props.label}
            defaultValue=""
            value={props.value}
            variant="outlined"
            onChange={props.onChange}
        />
    )
}


export default function UserEditParcel() {
    const classes = useStyles();
    const [parcelAttr, setParcelAttr] = useState({})
    const handleChange = (prop) => (event) => {
        setParcelAttr({ ...parcelAttr, [prop]: event.target.value });
    };
    useEffect(() => {
        setParcelAttr({
            'parcel_code': 'SF0000001',
            'content': '',
            'email': 'test@test.com',
            'wechat': 'wechat',
            'process_method': '',
            'weight': 0,
            'max_weight': 0
        })
    }, [])
    return (
        <div>
            <Paper className={classes.paper}>

                <Grid container spacing={3}>
                    <Grid item xs={2}>
                        <h3>管理包裹</h3>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} lg={2}>
                        <TextInput label='快递公司' value={parcelAttr['parcel_code']}
                            onChange={handleChange('parcel_code')} />
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} lg={2}>
                        <TextInput label='快递单号' value={parcelAttr['parcel_code']}
                            onChange={handleChange('parcel_code')} />
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} lg={2}>
                        <TextInput label='商品内容' value={parcelAttr['content']}
                            onChange={handleChange('content')} />
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} lg={6}>
                        <TextInput label='预计重量'
                            value={parcelAttr['weight']}
                            onChange={handleChange('weight')}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} lg={6}>
                        <TextInput label='所属线路'
                            value={parcelAttr['weight']}
                            onChange={handleChange('weight')}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <FormControl component="fieldset">
                            <FormLabel component="legend">包裹到仓库后处理方式</FormLabel>
                            <RadioGroup aria-label="gender" name="gender1" value={parcelAttr['process_method']} onChange={handleChange('process_method')}>
                                <FormControlLabel value="dispatch" control={<Radio />} label="直接发往海外" />
                                <FormControlLabel value="check" control={<Radio />} label="检查重量内容后处理(发货延迟)" />
                                <FormControlLabel value="return" control={<Radio />} label="直接退回/拒收" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} lg={6}>
                        是否需要拆包裹（所有衣服统一不会拆包，拆包裹后破损免责）
                    </Grid>
                </Grid>
                {parcelAttr['process_method'] == 'check' && (
                    <>
                        <Grid container spacing={3}>
                            <Grid item xs={12} lg={6}>
                                是否需要检查内容（需要与客服联系，发货延迟）
                        </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item xs={12} lg={6}>
                                <TextInput label='预计重量(如果重量)'
                                    value={parcelAttr['max_weight']}
                                    onChange={handleChange('max_weight')}
                                />
                            </Grid>
                        </Grid>
                    </>
                )}
                {parcelAttr['process_method'] == 'return' && (
                <Grid container spacing={3}>
                    <Grid item xs={12} lg={6}>
                        <TextInput label='退货地址'
                            value={parcelAttr['max_weight']}
                            onChange={handleChange('max_weight')}
                        />
                    </Grid>
                </Grid>
                )}
            </Paper>

        </div>
    )
}